const log = require('../log');
/**
 * Recursively search element ancestry to find a parent element that matches
 * `predicate`.
 *
 * Stops when predicate returns true or the `body` tag is encountered.
 *
 * @param  {Object} elem      A DOM node element
 * @param  {function} predicate function that returns true when match is found
 * @return Object             Match DOM element
 */
function findParentElement(elem, predicate) {
  if (!elem || !predicate) {
    log('[flow.js] Error - findParentElement: element and predicate are required');
    return undefined;
  }

  if (typeof predicate !== 'function') {
    log('[flow.js] Error - findParentElement: predicate must be a function');
    return undefined;
  }

  if (predicate(elem)) {
    return elem;
  }

  if (elem.nodeName === 'BODY') {
    return undefined;
  }

  if (elem.parentNode) {
    return findParentElement(elem.parentNode, predicate);
  }

  return undefined;
}

module.exports = findParentElement;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/dom/find-parent-element.js